// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "2fef185f" + "." + "355da9229a855e88" + ".js";
};